import {
  CircularProgress,
  Backdrop,
  Alert,
} from '@mui/material';

import { Modal} from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { SUCCESSFULLY_SAVE } from  '../const/Message';
import { TIMEOUT_DIALOG_MESSAGE } from  '../const/UI';

import BootstrapAlert from 'react-bootstrap/Alert';


import {
  Button,
} from '@mui/material';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export function BlockUI(){
    return(
        <Backdrop className="backdrop"
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 9999 }}
            open={true}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}

export function AlertMessage({type, messages }){
    if (messages === undefined || messages === null) return null;
    return (
        messages.map((d) => (
            <Alert key={d} severity={type}>{d}</Alert>
        ))
    );
}

export function BootstrapAlertMessage({type, messages, variant = "danger"}){
    if (messages === undefined || messages === null) return null;
    return (
       <div className="bootstrap-alert-container">
          {messages.map((d) => (
              <BootstrapAlert key={d} variant={variant} severity={type}>{d}</BootstrapAlert>
          ))}
        </div>
    );
}

export function DialogMessage({dialogSetting = {}, onClose = null })
{
    const [showModal, setShowModal] = useState(true);
    
    if (dialogSetting === null || dialogSetting === undefined || Object.keys(dialogSetting).length === 0) {
      dialogSetting.showCloseButton = false;
      dialogSetting.messages = [SUCCESSFULLY_SAVE];
    }
    
    useEffect(() => {
      if (!dialogSetting.showCloseButton)
      {
          if (showModal) {
            const timer = setTimeout(() => {
              setShowModal(false);
            }, TIMEOUT_DIALOG_MESSAGE); 
            return () => clearTimeout(timer);
          }
      }
    }, [showModal]); 

    return ( 
        <Modal show={showModal} className="bootstrap-modal">
          <Modal.Header closeButton>
            <Modal.Title>WMS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {dialogSetting.messages.join('<br>')}
          </Modal.Body>
          <Modal.Footer>
             {dialogSetting.showCloseButton && <Button variant="secondary" onClick={onClose} >Close</Button>}
          </Modal.Footer>
        </Modal>
    );
}

export function ChildModal({children, handleClose, title, width = '500px'})
{
  return(
    <div className="childModalContainer">
      <div className="childModal" style={{ width : width }}>
          <div className="modal-header">
            <div className="modal-title h4">{title}</div>
            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
          </div>
          {children}
      </div>
    </div>
  );
}